import { useState, useEffect } from 'react';
export function useLocalStorage(key, initialValue) {
    // Get stored value from localStorage or use initialValue
    var readValue = function () {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            var item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            console.warn("Error reading localStorage key \"".concat(key, "\":"), error);
            return initialValue;
        }
    };
    // State to store our value
    var _a = useState(readValue), storedValue = _a[0], setStoredValue = _a[1];
    // Return a wrapped version of useState's setter function that persists the new value to localStorage
    var setValue = function (value) {
        if (typeof window === 'undefined') {
            console.warn("Tried setting localStorage key \"".concat(key, "\" even though environment is not a browser"));
        }
        try {
            // Allow value to be a function so we have the same API as useState
            var valueToStore = value instanceof Function ? value(storedValue) : value;
            // Save to state
            setStoredValue(valueToStore);
            // Save to localStorage
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
            // Dispatch an event so other components can update
            window.dispatchEvent(new Event('local-storage-change'));
        }
        catch (error) {
            console.warn("Error setting localStorage key \"".concat(key, "\":"), error);
        }
    };
    // Listen for changes to this localStorage key in other windows
    useEffect(function () {
        var handleStorageChange = function () {
            setStoredValue(readValue());
        };
        // Listen to 'storage' event
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('local-storage-change', handleStorageChange);
        return function () {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('local-storage-change', handleStorageChange);
        };
    }, [key]);
    return [storedValue, setValue];
}
